import type { RouteLocation } from '#vue-router'
import { useCookie, useSessionExpiry } from '#imports'
import { bouncesMobilePayReturn, entersSignupPastFirstStep, stripsLoggedInAuthDialog } from './authRedirects'
import { landingPageRedirect } from './landingPageRedirect'

/**
 * Whether the middleware chain will redirect `to`, judged from the URL and cookies alone. Work
 * started ahead of the chain skips these, so a redirect never repeats it.
 */
export function isRedirectPredicted(to: RouteLocation, isServer = import.meta.server): boolean {
    const hasSession = !!useSessionExpiry().value
    const middleware = to.matched.flatMap(record => [record.meta.middleware].flat())

    if (to.path !== '/' && to.path.endsWith('/')) return true
    if (bouncesMobilePayReturn(to)) return true
    if (isServer) {
        const isExisting = hasSession || !!useCookie('loggedInBefore', { readonly: true }).value

        if (landingPageRedirect(to, isExisting)) return true
    }
    if (hasSession) return middleware.includes('guest-only') || !!to.query.returnUrl?.toString() || stripsLoggedInAuthDialog(to.query)

    return middleware.includes('require-auth') || (isServer && entersSignupPastFirstStep(to.query))
}
